module.exports = __webpack_public_path__ + "img/35.d7e0cde3.jpg";